import { Navbar, Main, Product, Footer, AnnouncementBar } from "../components";

function Home() {
  return (
    <>
  <AnnouncementBar />
  <Navbar />
      <Main />
      <Product />
      <Footer />
    </>
  )
}

export default Home